import { SVGProps } from 'react';

export const EnterKeyIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M20 7v3a3 3 0 0 1-3 3H6.4M9 10l-3 3 3 3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
